import PlateCellLines from './PlateCellLines';
import PlateDrugs from './PlateDrugs';
import { useState } from 'react';
import useNavbar from './useNavbar';

function getVariables(state, ){



  

}

function SearchList({selected,listName,state,set}){
  let [q,setQ] = useState("");

  const list = ({
    drugs:PlateDrugs,
    samples:PlateCellLines,
  })[listName];

  const filtered = q.trim() ? list.filter(x => x.toLowerCase().includes(q)) : list;

  return (
    <div>
      <input style={{width:'100%'}} onChange={e => setQ(e.target.value)}/>

      <div style={{height:100,overflowY:'scroll',marginTop:10,border:'1px solid #ccc'}}>
        {filtered.map(x => (
          <div onClick={() => {
            set({ inventoryItem:x, factorUnits:({ drugs:"M", samples:"cells" })[listName], });
          }} class={`${x===state.inventoryItem?"selected":"fs-alternating"}`}>
            &nbsp;{x}
          </div>
        ))}
      </div>
    </div>
  )

}

const options = [{_id:"samples",label:"Samples"},{_id:"drugs",label:"Compounds"}];

export default function PlateMaterialOptions({set,state}){


  const [selected,navbar] = useNavbar({options,fontSize:10, spread:false, type:"select"});
   

  return (
    <div style={{border:'1px solid #ccc',padding:10,borderRadius:5,width:150,position:'relative',}}>
      {navbar}
      <div style={{height:10}}/>
      <SearchList set={set} state={state} listName={selected}/>
    </div>
  )


}
